/**
 * Shared slide scanner constants used by both LDT and SAMD.
 */
import { SlideImageScannerType } from 'src/types';

export const SCANNER_SUPPORTED_EXTENSIONS: Record<
  SlideImageScannerType,
  Set<string>
> = {
  [SlideImageScannerType.HamamatsuNanozoomerS360]: new Set(['.ndpi']),
  [SlideImageScannerType.HamamatsuNanozoomerS360Md]: new Set(['.ndpi']),
  [SlideImageScannerType.PhilipsUltraFast]: new Set(['.isyntax']),
  [SlideImageScannerType.GrundiumOcus_20]: new Set(['.svs']),
  [SlideImageScannerType.LeicaGt450Dx]: new Set(['.svs']),
  [SlideImageScannerType.KfbioPro]: new Set(['.svs']),
  [SlideImageScannerType.ThreeDHistechP1000]: new Set(['.mrxs_zip', '.zip']),
};

export const SCANNER_TYPE_OPTIONS: {
  value: SlideImageScannerType;
  name: string;
}[] = [
  { value: SlideImageScannerType.GrundiumOcus_20, name: 'Grundium Ocus 20' },
  {
    value: SlideImageScannerType.HamamatsuNanozoomerS360,
    name: 'Hamamatsu Nanozoomer S360',
  },
  {
    value: SlideImageScannerType.HamamatsuNanozoomerS360Md,
    name: 'Hamamatsu Nanozoomer S360MD',
  },
  { value: SlideImageScannerType.PhilipsUltraFast, name: 'Philips Ultra Fast' },
  { value: SlideImageScannerType.LeicaGt450Dx, name: 'Leica Aperio GT450 DX' },
  { value: SlideImageScannerType.KfbioPro, name: 'KF-PRO Series' },
  { value: SlideImageScannerType.ThreeDHistechP1000, name: '3D Histech P1000' },
];
